var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',{staticClass:"flex justify-center"},[_c('span',{staticClass:"loading loading-infinity loading-lg"})]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }